import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<span class=\"mesh-descriptor-last-tree-number\" ...attributes>\n  {{this.value}}\n</span>\n", {
  moduleName: "ilios-common/components/mesh-descriptor-last-tree-number.hbs"
});